import * as React from "react";
import { TextInput, Button, Grid, Title, Card, Text, useMantineTheme } from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { QuerySetType } from "@supportinitiative/common";

import { escapeRegExp } from "../../utilities";
import { useQuerySets } from "../../hooks";
import Loading from "../../ui/Loading";
import { styles } from "../../styles";

function getIsMatch(filter: string) {
  const isMatch = (querySet: QuerySetType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return re.test(querySet.name) || re.test(querySet.displayName) || re.test(querySet.description);
  };
  return isMatch;
}

export default function QuerySets(props: { type?: string }) {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");

  let [filter, setFilter] = React.useState("");
  const { data: querySets, isLoading } = useQuerySets(entityId, props.type);
  const theme = useMantineTheme();

  const filteredQuerySets = querySets ? querySets.filter(getIsMatch(filter)) : [];

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>Querysets</Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/querysets/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredQuerySets.length > 0 ? (
            <Grid align="center" gutter={"xs"} mb="xs">
              {filteredQuerySets.map((querySet) => {
                return (
                  <Grid.Col span={3} key={querySet.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/querysets/edit?id=${querySet.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="querySet"
                    >
                      <Text fw={500}>{querySet.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {querySet.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing.lg,
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No query sets
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
